import { publicNamespaceUid } from "../../part";
export function relativePathForDocumentSnapshotDescriptor(descriptor, namespaceUid = publicNamespaceUid) {
    return `${namespaceUid}/p/${descriptor.schemaTag}/${descriptor.documentUid}/${descriptor.documentVersion}.json`;
}
//# sourceMappingURL=staticRefPaths.js.map